export enum RoleType {
    ADMIN = 'admin',
    DIREZIONE = 'direzione',
    ESTERNO = 'esterno',
}